import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import StatusTypes from "../../../StatusTypes";

export default class DeliveryStatusCell extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    deliveryDays: PropTypes.string,
    deliveryStatus: PropTypes.string
  };

  static defaultProps = {
    className: "",
    deliveryDays: "",
    deliveryStatus: ""
  };

  render() {
    const isDeliveryLate = this.props.deliveryStatus === StatusTypes.Late;

    return (
      <div className={classNames("sorted-list__data", this.props.className)}>
        <span className={classNames("sorted-list__delivery-status", isDeliveryLate ? "--delayed" : "--on-time")}>
          {isDeliveryLate ? `${i18n.t("loads.status.Delayed")} ${Math.abs(this.props.deliveryDays)}` : i18n.t("loads.status.OnTime")}
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PurchaseOrder/ListPage/List/PrePlanning/DeliveryStatusCell.js